const queryKeys = {
  connectWallet: 'connectWallet',
  tickets: 'tickets',
  subsetPerLevel: 'subsetPerLevel',
  paxgHistory: 'paxgHistory',
  transactions: 'transactions',
  tracerKey: 'tracerKey',
  platform: 'platform',
  goldStream: 'goldStream',
  token: 'token',
  balance: 'balance',
  signMessage: 'signMessage',
  convert: 'convert',
  referralDetails: 'referralDetails',
  loan: 'loanList',
  loanInfo: 'loanInfo',
  loanOverview: 'loanOverview',
  createLoan: 'createLoan',
  loanPay: 'loanPay',
  userLoans: 'userLoans',
  loanDetail: 'loanDetail',
  userLoanDetail: 'userLoanDetail',
  transferHistory: 'transferHistory',
};
export default queryKeys;
